<template>
    <div class="ah-page accounting-general-ledger">
        <div class="page-header">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>會計科目總分類帳</h1>
                    </div>
                    <div class="actions">
                        <el-button @click="onGoToEmptyPage" :type="emptyCount > 0 ? 'highlight' : 'normal'" :disabled="emptyCount === 0" icon="el-icon-warning">
                            <span>{{ currQueryYear }} 年度會計科目空白 {{ emptyCount }} 筆</span>
                        </el-button>
                        <el-button @click="onExportExcel">匯出Excel</el-button>
                    </div>
                </div>
                <div style="height: 80px"></div>
            </div>
        </div>
        <div class="row" style="margin-top: -85px; margin-bottom: -32px">
            <div class="ah-container">
                <div class="ah-panel">
                    <div class="panel-body">
                        <search-form>
                            <search-form-item label="科目類型">
                                <el-radio-group v-model="queryParams.QueryType" @change="updateData">
                                    <el-radio-button :label="1">明細科目</el-radio-button>
                                    <el-radio-button :label="2">統制科目</el-radio-button>
                                </el-radio-group>
                            </search-form-item>
                            <search-form-item label="查詢期間">
                                <ahDropdownDatePicker v-model="dateRange" :openDate="openDate" @change="updateData" />
                            </search-form-item>
                            <search-form-item :label="queryParams.QueryType === 1 ? '明細科目起迄' : '統制科目起迄'">
                                <div class="horizontal-inputs">
                                    <ah-select-accounting-setting v-model="queryParams.AccountStart" :queryType="queryParams.QueryType" align="center" clearable style="width: 261px" />
                                    <span class="spacer">至</span>
                                    <ah-select-accounting-setting v-model="queryParams.AccountEnd" :queryType="queryParams.QueryType" align="center" clearable style="width: 250px" />
                                    <el-button type="primary" class="button" @click="updateData" icon="el-icon-search">查詢</el-button>
                                </div>
                            </search-form-item>
                        </search-form>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 40px">
            <div class="ah-container">
                <div class="ah-panel">
                    <div class="panel-body" style="padding: 20px 50px">
                        <ah-sticky-el-table-header>
                            <el-table :data="datas" v-loading="isLoading" empty-text="查無資料" size="small" :row-class-name="rowClassName" class="accounting-general-ledger-table">
                                <el-table-column prop="accno" label="科目代號" width="80">
                                    <template slot-scope="scope">
                                        <div v-if="scope.row.firstAccno">{{ scope.row.accno }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="accnam" label="科目名稱" width="150">
                                    <template slot-scope="scope">
                                        <div v-if="scope.row.firstAccno">{{ scope.row.accnam }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="dC_TYP" label="科目屬性" width="80">
                                    <template slot-scope="scope">
                                        <div>
                                            <span v-if="scope.row.dC_TYP === 1" class="accouting-dc-label dr">借</span>
                                            <span v-else class="accouting-dc-label cr">貸</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="dat" label="傳票日期" width="105">
                                    <template slot-scope="scope">
                                        <div v-if="scope.row.dat">{{ getChtDate(scope.row.dat) }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="serialNumber" label="傳票號碼" width="110">
                                    <template slot-scope="scope">
                                        <el-button v-if="scope.row.serialNumber" type="text" @click="onVonoClick(scope.row.vono)">{{ scope.row.serialNumber }}</el-button>
                                        <div v-else style="padding: 8px 0; cursor: default">--</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="content" label="摘要" show-overflow-tooltip />
                                <el-table-column prop="crD_NTD" label="借方金額" width="130" align="right">
                                    <template slot-scope="scope">
                                        <Money :v="scope.row.crD_NTD" v-if="scope.row.crD_NTD !== 0" />
                                    </template>
                                </el-table-column>
                                <el-table-column prop="deB_NTD" label="貸方金額" width="130" align="right">
                                    <template slot-scope="scope">
                                        <Money :v="scope.row.deB_NTD" v-if="scope.row.deB_NTD !== 0" />
                                    </template>
                                </el-table-column>
                                <el-table-column prop="crD_Balance" label="餘額" width="130" align="right">
                                    <template slot-scope="scope">
                                        <Money v-if="scope.row.dC_TYP === 1" :v="scope.row.crD_Balance" />
                                        <Money v-if="scope.row.dC_TYP === 2" :v="scope.row.deB_Balance" />
                                    </template>
                                </el-table-column>
                            </el-table>
                        </ah-sticky-el-table-header>
                        <div class="pagination">
                            <el-pagination
                                layout="prev, pager, next"
                                :page-size.sync="queryParams.PageSize"
                                :total.sync="totalDataCount"
                                :current-page.sync="queryParams.PageNum"
                                @current-change="updateData"
                            >
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <VoucherDetail :visible="voucherDetail.visible" :vono="voucherDetail.vono" @close="onVoucherDetailCLose" />
    </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import VoucherDetail from '@/components/dashboard/Accounting/AccountingVoucherList/ui/VoucherDetail.vue';
import ahSelectAccountingSetting from '@/components/ui/ahSelectAccountingSetting.vue';
import ahStickyElTableHeader from '@/components/ui/ahStickyElTableHeader.vue';
import ahDropdownDatePicker from '@/components/ui/ahDropdownDatePicker.vue';
import SearchForm from '@/components/ui/SearchForm/SearchForm.vue';
import SearchFormItem from '@/components/ui/SearchForm/SearchFormItem.vue';
import { downloadExcel } from './exportExcelUtils';

export default {
    name: 'AccountingAccountBalanceSpreadsheet',
    components: {
        VoucherDetail,
        ahSelectAccountingSetting,
        ahStickyElTableHeader,
        ahDropdownDatePicker,
        SearchForm,
        SearchFormItem,
    },
    data() {
        return {
            isLoading: false,
            dateRange: [null, null],
            queryParams: {
                QueryType: 1,
                StartDate: null,
                EndDate: null,
                AccountStart: null,
                AccountEnd: null,
                PageSize: 25,
                PageNum: 1,
            },
            voucherDetail: {
                visible: false,
                transactionType: null,
                vono: null,
            },
            yearVoucherDetail: {
                visible: false,
                transactionType: null,
                vono: null,
            },
            datas: [],
            totalDataCount: 0,
            emptyCount: 0,
            openDate: null,
            currQueryYear: null,
        };
    },
    computed: {
        pickerYearOptions() {
            const START_YEAR = 2020;
            const CURR_YEAR = new Date().getFullYear();
            const shortcuts = [];
            for (let y = CURR_YEAR; y >= START_YEAR; y -= 1) {
                shortcuts.push({
                    text: `${y}`,
                    onClick(picker) {
                        const sd = Number(moment([y]).startOf('year').format('x'));
                        const ed = Number(moment([y]).endOf('year').format('x'));
                        picker.$emit('pick', [sd, ed]);
                    },
                });
            }
            return { shortcuts };
        },
        isStartEndDateSameYear() {
            return moment(Number(this.dateRange[0])).year() === moment(Number(this.dateRange[1])).year();
        },
        companyName() {
            return this.$store.getters['menu/companyInfo'].cH_CMP;
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            const today = moment();
            if (this.$route.query.StartDate && this.$route.query.EndDate) {
                this.dateRange = [this.$route.query.StartDate, this.$route.query.EndDate];
            } else this.dateRange = [today.startOf('year').format('x'), today.endOf('year').format('x')];

            await this.$store.dispatch('accounting/updateAccountingSettings');
            await this.updateData();
        },
        async getYearlyOpenVoucher() {
            const OPEN_DATE = moment(+this.openDate);
            const SELECTED_END_DATE = moment(+this.queryParams.EndDate);
            const SELECTED_START_DATE = moment(+this.queryParams.StartDate);

            if (this.openDate && OPEN_DATE.year() === SELECTED_END_DATE.year() && SELECTED_START_DATE.isAfter(OPEN_DATE)) return;
            if (OPEN_DATE.year() === SELECTED_END_DATE.year() && SELECTED_START_DATE.isBefore(OPEN_DATE)) {
                this.$message({
                    showClose: true,
                    message: `${SELECTED_START_DATE.year()}年開帳日期為 ${OPEN_DATE.format('YYYY-MM-DD')}，已自動將查詢起日設為開帳日期。`,
                    type: 'warning',
                });
            }

            const resp = await this.$api({
                url: 'AccountingSummaryPage/QueryVouchers',
                method: 'GET',
                params: {
                    StartDateStart: moment(+this.queryParams.StartDate).startOf('year').format('x'),
                    StartDateEnd: moment(+this.queryParams.StartDate).endOf('year').format('x'),
                    TransactionType: 12,
                },
            });

            if (resp.data.totalNum) {
                this.openDate = _.head(resp.data.items)?.dat;
                this.dateRange = [this.openDate, this.dateRange[1]];
            } else this.openDate = null;

            this.updateQuery();
        },
        updateQuery() {
            this.queryParams.StartDate = moment(+_.head(this.dateRange)).startOf('day').format('x');
            this.queryParams.EndDate = moment(+_.last(this.dateRange)).endOf('day').format('x');

            if (this.queryParams.StartDate !== this.$route.query.StartDate || this.queryParams.EndDate !== this.$route.query.EndDate) {
                this.$router.push({
                    name: this.$route.name,
                    query: {
                        StartDate: this.queryParams.StartDate,
                        EndDate: this.queryParams.EndDate,
                    },
                });
            }
        },
        checkQueryValidate() {
            const OPEN_DATE = moment(+this.openDate);
            const SELECTED_DATE = moment(+this.queryParams.EndDate);
            if (this.openDate && SELECTED_DATE.isBefore(OPEN_DATE)) {
                this.$message({
                    showClose: true,
                    message: `${SELECTED_DATE.year()}年開帳日期為 ${OPEN_DATE.format('YYYY-MM-DD')}，請重新選擇日期範圍。`,
                    type: 'error',
                });
                return false;
            }
            return true;
        },
        async updateData() {
            if (!this.isStartEndDateSameYear) {
                this.$message({
                    showClose: true,
                    message: '不可跨年度查詢，請重新選擇日期範圍。',
                    type: 'error',
                });
                return;
            }
            this.updateQuery();
            await this.getYearlyOpenVoucher();
            if (!this.checkQueryValidate()) return;

            this.isLoading = true;
            try {
                const resp = await this.$api({
                    url: '/AccountingSummaryReport/QueryGeneralLedger',
                    method: 'GET',
                    params: this.queryParams,
                });

                this.datas = this.normalizeDataForDisplay(resp.data.items);
                this.totalDataCount = resp.data.totalNum;
                this.emptyCount = resp.data.accnoEmptyNum;

                this.currQueryYear = moment(+this.queryParams.StartDate).year() - 1911;
            } finally {
                this.isLoading = false;
            }
        },
        getManualQuery(query) {
            if (!query.accnoEnd && !query.accnoStart) return { query: '' };

            const SETTINGS = this.$store.getters['accounting/settingsForSelect'];
            const START = query.accnoStart ? Number(query.accnoStart[0]) : 1;
            const END = query.accnoEnd ? Number(query.accnoEnd[0]) : 9;

            //  get range
            const range = [];
            for (let i = START; i <= END; i += 1) {
                range.push(i);
            }
            const FOUNDED = _.chain(SETTINGS)
                .flatMap((o) => (range.includes(Number(o.label[0])) ? o.children : []))
                .filter((o) => Number(query.accnoStart) <= Number(o.accno.split('-')[0]) && Number(o.accno.split('-')[0]) <= Number(query.accnoEnd || 10000))
                .value();
            const returnValue = [..._.map(FOUNDED, (o) => `Accounts=${o.accno}`)];
            return {
                query: returnValue.length ? `?${returnValue.join('&')}` : '',
                resetQuery: { accnoStart: undefined, accnoEnd: undefined },
            };
        },
        onVonoClick(vono, transactionType) {
            this.voucherDetail.visible = true;
            this.voucherDetail.vono = vono;
            this.voucherDetail.transactionType = transactionType;
        },
        onVoucherDetailCLose(refresh) {
            this.voucherDetail.visible = false;
            this.voucherDetail.vono = null;
            this.voucherDetail.transactionType = null;
            if (refresh) {
                this.updateData();
            }
        },
        // 將資料格式化為符合總分類帳的資料格式：
        // 科目代號＆名稱只出現在第一筆
        normalizeDataForDisplay(rawItems) {
            const outputList = [];

            let lastAccno = null;
            for (let i = 0; i < rawItems?.length; i += 1) {
                const rawItem = rawItems[i];
                if (lastAccno !== rawItem.accno) {
                    // 是第一次遇到該科目
                    rawItem.firstAccno = true;
                    outputList.push(rawItem);
                    lastAccno = rawItem.accno;
                } else {
                    // 非第一次
                    const item = rawItem;
                    item.firstAccno = false;
                    outputList.push(item);
                }
            }
            return outputList;
        },
        rowClassName({ row }) {
            if (row.firstAccno) return 'first-accno-row';
            return 'normal-accno-row';
        },
        getChtDate(timestamp) {
            return `${moment(timestamp).year() - 1911}-${moment(timestamp).format('MM-DD')}`;
        },
        onGoToEmptyPage() {
            this.$router.push({
                name: 'accounting-general-ledger-empty',
                query: {
                    year: this.currQueryYear,
                },
            });
        },
        onExportExcel() {
            downloadExcel(this.queryParams, this.companyName, null);
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.accounting-general-ledger {
    &.ah-page {
        padding-bottom: 15px;
    }

    .pagination {
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        background-color: #fff;
    }

    .accouting-dc-label {
        &.dr {
            color: #f55c5c;
        }
        &.cr {
            color: #56c500;
        }
    }

    .accounting-general-ledger-table {
        border-bottom: 1px solid #ddd;

        .el-table__row {
            td {
                color: #000;
                font-size: 10pt;
                padding-top: 0;
                padding-bottom: 0;
                border-top: 1px solid #ddd;
                border-bottom: 0;

                &:nth-child(1),
                &:nth-child(2) {
                    border-top: transparent;
                    background-color: transparent;
                }
            }
        }
        .el-table__row.first-accno-row > td {
            border-top: 1px solid #000;
        }
    }
}
</style>
